import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import './data-renderer.scss';

export class CardList extends PureComponent {
  render() {
    return (
      <div className="card-list">
        <ul>
          {this.props.items.map((item, key) =>
            <li key={key}>
              {item}
            </li>
          )}
        </ul>
      </div>
    );
  }
}

CardList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.node),
  isMobile: PropTypes.bool
};

export class CardSlider extends PureComponent {
  render() {
    const defaultSettings = {
      draggable: !!this.props.isMobile,
      infinite: false,
      slidesToShow: 3,
      centerPadding: '0',
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    };

    const settings = Object.assign(
      defaultSettings,
      this.props.settings || {}
    );

    return (
      <div className="card-slider">
        <Slider {...settings}>
          {this.props.items.map((item, key) =>
            <div key={key}>
              {item}
            </div>
          )}
        </Slider>
      </div>
    );
  }
}

CardSlider.propTypes = {
  items: PropTypes.arrayOf(PropTypes.node),
  settings: PropTypes.object,
  isMobile: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/widgets/DataRenderer/index.js